import { observer } from 'mobx-react-lite';
import React from 'react';

import { Icon, IconLink } from '@flixbus/honeycomb-icons-react';

import { rideDetailsStore } from 'pages/RideDetails/RideDetailsStore';

import styles from './styles.module.css';

const BatchSegmentController = observer(({ batchData }) => {
	const { setBatchSelectionOn, setBatchSelectionOff, createBatch } = rideDetailsStore;
	return (
		<div className={styles.batch}>
			<div
				onMouseEnter={() => setBatchSelectionOn(batchData)}
				onMouseLeave={() => setBatchSelectionOff(batchData)}
				onClick={() => createBatch(batchData)}
				className={styles.link}
			>
				<Icon InlineIcon={IconLink} />
			</div>
		</div>
	);
});

export default BatchSegmentController;
